import mitt from '~/libraries/mitt';
const emitter = mitt<any>();
export default defineNuxtPlugin({
  setup() {
    return {
      provide: {
        bus: {
          $on: emitter.on,
          $off: emitter.off,
          $emit: emitter.emit,
        },
      },
    };
  },
});
